import * as i0 from '@angular/core';
import { HostBinding, Input, Directive, NgModule, inject, Injectable } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

/**
 * Can but should not be used directly. Should be used as a base class for other components and directives.
 */
class ColorableDirective {
  get primary() {
    return this.color === 'primary';
  }
  get secondary() {
    return this.color === 'secondary';
  }
  get info() {
    return this.color === 'info';
  }
  get warn() {
    return this.color === 'warn';
  }
  get success() {
    return this.color === 'success';
  }
  get error() {
    return this.color === 'error';
  }
  get subdued() {
    return this.color === 'subdued';
  }
  get dark() {
    return this.color === 'dark';
  }
  get light() {
    return this.color === 'light';
  }
  static {
    this.ɵfac = function ColorableDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ColorableDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: ColorableDirective,
      selectors: [["", "stlrColorable", ""]],
      hostVars: 18,
      hostBindings: function ColorableDirective_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassProp("primary", ctx.primary)("secondary", ctx.secondary)("info", ctx.info)("warn", ctx.warn)("success", ctx.success)("error", ctx.error)("subdued", ctx.subdued)("dark", ctx.dark)("light", ctx.light);
        }
      },
      inputs: {
        color: "color"
      },
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ColorableDirective, [{
    type: Directive,
    args: [{
      selector: '[stlrColorable]',
      standalone: false
    }]
  }], null, {
    color: [{
      type: Input
    }],
    primary: [{
      type: HostBinding,
      args: ['class.primary']
    }],
    secondary: [{
      type: HostBinding,
      args: ['class.secondary']
    }],
    info: [{
      type: HostBinding,
      args: ['class.info']
    }],
    warn: [{
      type: HostBinding,
      args: ['class.warn']
    }],
    success: [{
      type: HostBinding,
      args: ['class.success']
    }],
    error: [{
      type: HostBinding,
      args: ['class.error']
    }],
    subdued: [{
      type: HostBinding,
      args: ['class.subdued']
    }],
    dark: [{
      type: HostBinding,
      args: ['class.dark']
    }],
    light: [{
      type: HostBinding,
      args: ['class.light']
    }]
  });
})();
class StlrUtilitiesModule {
  static {
    this.ɵfac = function StlrUtilitiesModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrUtilitiesModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StlrUtilitiesModule,
      declarations: [ColorableDirective],
      imports: [CommonModule],
      exports: [ColorableDirective]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrUtilitiesModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule],
      declarations: [ColorableDirective],
      exports: [ColorableDirective]
    }]
  }], null, null);
})();
class ScreenSizeService {
  get isMobileScreen() {
    return this._isMobileScreen || false;
  }
  get isSmallScreen() {
    return this._isSmallScreen || false;
  }
  constructor() {
    this.destroy$ = new Subject();
    this._breakpointObserver = inject(BreakpointObserver);
    this.isMobileScreen$ = this._breakpointObserver.observe('(max-width: 37.5em)').pipe(takeUntil(this.destroy$));
    this.isSmallScreen$ = this._breakpointObserver.observe('(max-width: 80em)').pipe(takeUntil(this.destroy$));
    this.isMobileScreen$.pipe(takeUntil(this.destroy$)).subscribe(value => this._isMobileScreen = value.matches);
    this.isSmallScreen$.pipe(takeUntil(this.destroy$)).subscribe(value => this._isSmallScreen = value.matches);
  }
  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
  static {
    this.ɵfac = function ScreenSizeService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || ScreenSizeService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: ScreenSizeService,
      factory: ScreenSizeService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ScreenSizeService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [], null);
})();

// NOTE: This won't import into apps for some reason. Receive error: No matching export in ... for import "Range".
// A copy of it is temporarily in the progress-bar library and not exported externally.
// export * from './lib/decorators/range';

/**
 * Generated bundle index. Do not edit.
 */

export { ColorableDirective, ScreenSizeService, StlrUtilitiesModule };
